import { SVGProps } from 'react'
import { motion } from 'framer-motion'

interface HamburgerIconProps extends SVGProps<SVGSVGElement> {
  isOpen?: boolean
}

const HamburgerIcon = ({
  isOpen,
  color = '#1A1E3D',
  ...props
}: HamburgerIconProps) => {
  return (
    <motion.svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      animate={{ rotate: isOpen ? 180 : 0 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      {...(props as any)} // Type assertion to bypass type incompatibility
    >
      {isOpen ? (
        <>
          <motion.line
            x1="3"
            y1="3"
            x2="21"
            y2="21"
            stroke={color}
            strokeWidth="3"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.3 }}
          />
          <motion.line
            x1="21"
            y1="3"
            x2="3"
            y2="21"
            stroke={color}
            strokeWidth="3"
            strokeLinecap="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.3, delay: 0.1 }}
          />
        </>
      ) : (
        <>
          <motion.rect
            y="7"
            width="24"
            height="3"
            rx="1"
            fill={color}
            initial={{ x: -10, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3 }}
          />
          <motion.rect
            y="15"
            width="24"
            height="3"
            rx="1"
            fill={color}
            initial={{ x: -10, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.1 }}
          />
        </>
      )}
    </motion.svg>
  )
}

export default HamburgerIcon
